module.exports = __webpack_public_path__ + "img/two-2.6728f866.png";